import axios from "axios";

const Promocodes = async (promocodes, image_en, image_ar) => {
  try {
    const formData = new FormData();
    formData.append("promocodes", JSON.stringify(promocodes));
    
    if (image_en && image_en !== "undefined" && image_en !== "") {
      formData.append("image_en", image_en);
    }
    if (image_ar && image_ar !== "undefined" && image_ar !== "") {
      formData.append("image_ar", image_ar);
    }

    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/promocodes`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.success) {
      return 200;
    } else {
      return 404;
    }
  } catch (err) {
    console.error("tsts: ", err);
    return 404;
  }
};

export default Promocodes;
